<template>
  <div class="myProduct">
    <a-row
      v-if="editId == 0 && confirmId == 0"
      :gutter="24"
    >
      <a-col span="12">
        <a-row>
          <a-col span="10">
            <div class="searchBox">
              <div style="width: 6em;line-height: 32px;">
                {{ $t('admin-message-message/name') }}
              </div>
              <a-input-search
                v-model="keyWord"
                style="height: 32px;"
                :placeholder="$t('user-productInfo-myProduct/code')"
              />
            </div>
          </a-col>
          <a-col span="10">
            <div class="searchBox">
              <div style="width: 6em;line-height: 32px; margin-right: 10px;">
                {{ $t('view-components-components/productStatus') }}
              </div>
              <a-select
                v-model="register_status"
                style="width: 100%;"
              >
                <a-select-option
                  key="-1"
                  :value="-1"
                >
                  {{ $t('admin-judge/total') }}
                </a-select-option>
                <a-select-option
                  key="0"
                  :value="0"
                >
                  {{ $t('user-tools/notCompleted') }}
                </a-select-option>
                <a-select-option
                  key="1"
                  :value="1"
                >
                  {{ $t('user-tools/RegisteredForPreliminaryReview') }}
                </a-select-option>
                <a-select-option
                  key="2"
                  :value="2"
                >
                  {{ $t('admin-products-products/shortlisted') }}
                </a-select-option>
                <a-select-option
                  key="-2"
                  :value="-2"
                >
                  审核未通过
                </a-select-option>
                <a-select-option
                  key="3"
                  :value="3"
                >
                  {{ $t('user-tools/success') }}
                </a-select-option>
                <a-select-option
                  key="4"
                  :value="4"
                >
                  <span style="color: #5B9BD5;font-weight: bold;">{{ $t('admin-products-products/winning') }}</span>
                </a-select-option>
                <a-select-option
                  key="5"
                  :value="5"
                >
                  <span style="color: #FF0000;font-weight: bold;">{{ $t('admin-products-products/silveraward') }}</span>
                </a-select-option>
                <a-select-option
                  key="6"
                  :value="6"
                >
                  <span style="color: #ED7D31;font-weight: bold;">{{ $t('admin-products-products/goldaward') }}</span>
                </a-select-option>
                <a-select-option
                  key="7"
                  :value="7"
                >
                  优胜奖
                </a-select-option>
                <a-select-option
                  key="8"
                  :value="8"
                >
                  入围
                </a-select-option>
              </a-select>
            </div>
          </a-col>
          <a-col span="4">
            <div class="searchBox" style="justify-content: center;">
              <a-button type="primary" @click="getList">{{ $t('user-productInfo-myProduct/search') }}</a-button>
            </div>
          </a-col>
        </a-row>
      </a-col>
      <a-col span="12">
        <div class="infoBox">
          <a-row :gutter="24">
            <a-col span="8">
              <a-icon type="idcard" />
              <span>{{ $t('user-productInfo-myProduct/contactPerson') }}</span>
            </a-col>
            <a-col span="16">
              <!-- {{ user.lastname + ' ' + user.firstname }} -->
              {{ $t('user-productInfo-myProduct/contactPersonValue') }}
            </a-col>
          </a-row>
          <a-row
            :gutter="24"
            style="margin-top: 6px;"
          >
            <a-col span="8">
              <a-icon type="phone" />
              <span>{{ $t('user-productInfo-myProduct/contactPhone') }}</span>
            </a-col>
            <a-col span="16">
              <!-- {{ user.phone ? user.phone : '13459246093' }} -->
              (0596) 230 1770、202 2795
            </a-col>
          </a-row>
          <a-row
            :gutter="24"
            style="margin-top: 6px;"
          >
            <a-col span="8">
              <svg-icon icon-class="Email" />
              <span>{{ $t('user-productInfo-myProduct/emailAddress') }}</span>
            </a-col>
            <a-col span="16">
              <!-- {{ user.email ? user.email : 'xmgcd@xmcci.com' }} -->
              zzid2020@163.com
            </a-col>
          </a-row>

        </div>
      </a-col>
    </a-row>
    <a-table v-if="editId == 0 && confirmId == 0" :columns="columns" :data-source="data" class="table" :row-key="'id'" :pagination="pagination" :scroll="{ y: 'calc(100vh - 230px)', x: 1200 }" @change="pageChange">
      <span slot="index" slot-scope="text,row,index">
        <div>
          {{ index + 1 + (pagination.current - 1) * 10 }}
        </div>
      </span>
      <span slot="register_status_name" slot-scope="text">
        <span v-if="text === $t('admin-products-products/goldaward')" style="color: #ED7D31;font-weight: bold;">{{ text }}</span>
        <span v-else-if="text === $t('admin-products-products/silveraward')" style="color: #FF0000;font-weight: bold;">{{ text }}</span>
        <span v-else-if="text === $t('admin-products-products/winning')" style="color: #5B9BD5;font-weight: bold;">{{ text }}</span>
        <span v-else-if="text"> {{ text }}</span>
      </span>
      <span slot="view" slot-scope="text, row" class="edit" style="display: flex; gap: 5px; flex-wrap: nowrap;">
        <a-button size="small" @click="view(row)">{{ $t('view-components-components/view') }}</a-button>
        <a-button v-if="row.edit_status" size="small" @click="edit(row)">{{ $t('user-address/edit') }}</a-button>
        <a-button size="small" type="primary" @click="downloadForm(row)">下载报名表</a-button>
        <a-button v-if="canDelete(row)" size="small" type="danger" @click="confirmDelete(row)">删除</a-button>
        <span v-if="row.feedback" title="反馈"><svg-icon icon-class="qunfaxinxi" style="transform: scale(1.2);" @click="viewFeedback(row)" /></span>

        <!-- <span v-if="row.register_status == 3" :title="$t('view-components-components/reAndDelivery')" style="margin-left: 5px;"><svg-icon icon-class="chat" style="transform: scale(1.2);" @click="goJudging(row.id)" /></span> -->
        <!-- <span v-if="row.register_status > 3" :title="$t('view-components-components/winnerService')" style="margin-left: 5px;"><svg-icon icon-class="badge" style="transform: scale(1.2);" @click="goService(row.id)" /></span> -->
        <!-- <span v-if="row.register_status > 3 && row.is_confirmation_status" :title="$t('view-components-components/productConfirm')" style="margin-left: 5px;"><svg-icon icon-class="confirm" style="transform: scale(1.2);" @click="edit(row, true)" /></span> -->
      </span>
      <span slot="check" slot-scope="text, row" class="edit">
        <!-- <span v-if="row.edit_status" :title="$t('user-address/edit')"><svg-icon icon-class="write" @click="edit(row)" /></span> -->
        <!-- <span v-if="row.register_status == 3" :title="$t('view-components-components/reAndDelivery')" style="margin-left: 5px;"><svg-icon icon-class="chat" style="transform: scale(1.2);" @click="goJudging(row.id)" /></span> -->
        <!-- <span v-if="row.register_status > 3" :title="$t('view-components-components/winnerService')" style="margin-left: 5px;"><svg-icon icon-class="badge" style="transform: scale(1.2);" @click="goService(row.id)" /></span> -->
        <span v-if="row.is_confirmation_status || row.confirmation_status" :style="row.confirmation_status ? 'color: #ed1c24;' : ''" :title="$t('view-components-components/productConfirm')"><svg-icon icon-class="confirm" style="transform: scale(1.2);" @click="confirm(row)" /></span>
      </span>
      <span
        slot="register_status"
        slot-scope="text"
      >
        {{ text == 0 ? $t("user-tools/notCompleted") : '' }}
        {{ text == 1 ? $t("user-tools/RegisteredForPreliminaryReview") : '' }}
        {{ text == 2 ? $t("admin-products-products/shortlisted") : '' }}
        {{ text == 3 ? $t("user-tools/success") : '' }}
        {{ text == 6 ? '提名奖' : '' }}
        <span v-if="text == 4" style="color: #5B9BD5;font-weight: bold;">{{ $t('admin-products-products/winning') }}</span>
        <span v-if="text == 5" style="color: #ED7D31;font-weight: bold;">{{ $t('admin-products-products/goldaward') }}</span>
      </span>
    </a-table>
    <registrate
      v-if="editId != 0"
      :edit-id="editId"
      :product-confirm="productConfirm"
      @setEditId="setEditId"
    />
    <ConfirmBox v-if="confirmId != 0" :confirm-id="confirmId" :readonly="confirmation_status === 1" @goBack="goBack" />
    <Modal
      :show-modal="showModal"
      :show-confirm="false"
      cancel-text="关闭"
      @cancel="showModal = false"
    >
      <div style="overflow: auto;max-height: 50vh;">{{ content }}</div>
    </Modal>
  </div>
</template>
<script>
import { myProducts, productsIndexBefore, deleteProduct, productsWordExport } from '@/api/product'
import registrate from '../registration'
import { getPageKey, setPageKey, removePageKey } from '@/utils/auth'
import ConfirmBox from '@/views/components/ConfirmBox'
import Modal from '@/views/components/Modal.vue'

const columns = [
  {
    title: '序号',
    dataIndex: 'index',
    scopedSlots: { customRender: 'index' },
    width: '70px'
  },
  {
    title: '参赛编号',
    dataIndex: 'pi_code',
    width: '280px'
  },
  {
    title: '作品名称（中文）',
    dataIndex: 'name_cn'
  },
  // {
  //   title: '作品类型(中文)',
  //   dataIndex: 'type_cn'
  // },
  {
    title: '作品状态',
    dataIndex: 'register_status_name',
    scopedSlots: { customRender: 'register_status_name' }
  },
  // {
  //   title: '缴费状态',
  //   dataIndex: 'pay_status_name'
  // },
  {
    title: '作品查看',
    scopedSlots: { customRender: 'view' },
    width: '240px'
  },
  {
    title: '获奖信息校对',
    scopedSlots: { customRender: 'check' },
    width: '120px'
  }
]

export default {
  components: {
    registrate,
    ConfirmBox,
    Modal
  },
  data() {
    return {
      data: [],
      keyWord: '',
      register_status: -1,
      pagination: {
        current: 1,
        total: 0
      },
      columns,
      user: {
        firstname: '',
        lastname: '',
        email: '',
        phone: ''
      },
      editId: 0,
      productConfirm: false, // 是否作品确认
      confirmId: 0,
      confirmation_status: '',
      dataBackup: {},
      showModal: false,
      content: ''
    }
  },
  computed: {
    locale() {
      return this.$i18n.locale
    }
  },
  watch: {
    locale(e) {
      console.log(e) // 根据e对变量重新赋值
      this.columns[0].title = this.$t('admin-judge/index')
      this.columns[1].title = this.$t('user-tools/code')
      this.columns[2].title = e === 'en' ? this.$t('user-productInfo-product/productEname') : this.$t('user-productInfo-product/productName')
      // this.columns[2].title = e === 'en' ? this.$t('user-productInfo-product/typeEn') : this.$t('user-productInfo-product/type')
      this.columns[3].title = this.$t('view-components-components/productStatus')
      // this.columns[3].title = this.$t('view-components-components/paymentStatus')
      // this.columns[4].title = this.$t("user-tools/code");
      this.columns[2].dataIndex = e === 'en' ? 'name_en' : 'name_cn'
      // this.columns[2].dataIndex = e === 'en' ? 'type_en' : 'type_cn'
    }
  },
  created() {
    this.columns[0].title = this.$t('admin-judge/index')
    this.columns[1].title = this.$t('user-tools/code')
    this.columns[2].title = this.locale === 'en' ? this.$t('user-productInfo-product/productEname') : this.$t('user-productInfo-product/productName')
    // this.columns[2].title = this.locale === 'en' ? this.$t('user-productInfo-product/typeEn') : this.$t('user-productInfo-product/type')
    this.columns[3].title = this.$t('view-components-components/productStatus')
    // this.columns[3].title = this.$t('view-components-components/paymentStatus')
    // this.columns[4].title = this.$t("user-tools/code");
    this.columns[2].dataIndex = this.locale === 'en' ? 'name_en' : 'name_cn'
    // this.columns[2].dataIndex = this.locale === 'en' ? 'type_en' : 'type_cn'
    this.getList()
    productsIndexBefore()
      .then(res => {
        if (res.user) {
          this.user = res.user
        }
      })
      .catch(res => {
        console.error(res)
      })
    const id = getPageKey('editProductId')
    if (id) this.editId = id
    const productConfirm = getPageKey('productConfirm')
    this.productConfirm = productConfirm
  },
  methods: {
    onSearch() {
      console.log('search')
    },
    getList(page) {
      const params = {
        search: this.keyWord,
        page: typeof page === 'number' ? page : 1
      }
      if (this.register_status) {
        params.register_status = this.register_status
      }
      myProducts(params)
        .then(res => {
          this.data = res.data
          console.log(this.data[0]['register_status_name'])
          this.pagination.total = res.total
          this.pagination.current = res.current_page
        })
        .catch(res => {
          console.error(res)
        })
    },
    view(row) {
      this.editId = row.id
      setPageKey('editProductId', row.id)
      setPageKey('readonly', 'true')
    },
    edit(row, bool) {
      console.log('row', row)
      removePageKey('productStep')
      this.editId = row.id
      setPageKey('editProductId', row.id)
      this.productConfirm = !!bool
      setPageKey('productConfirm', !!bool)
    },
    confirm(row) {
      this.confirmId = row.id
      this.confirmation_status = row.confirmation_status
    },
    pageChange(e) {
      this.getList(e.current)
    },
    setEditId(value) {
      this.editId = value
    },
    goJudging(id) {
      removePageKey('productStep')
      setPageKey('editProductId', id)
      this.$router.push({ path: '/user/onSiteJudging' })
    },
    goService(id) {
      removePageKey('productStep')
      setPageKey('editProductId', id)
      this.$router.push({ path: '/user/winnerService' })
    },
    goBack() {
      this.confirmId = 0
      this.getList(this.pagination.current)
    },
    viewFeedback(row) {
      this.content = row.feedback
      this.showModal = true
    },
    /**
     * @description 判断是否可以删除作品
     * @param {Object} row 作品行数据
     * @returns {Boolean} 是否可以删除
     */
    canDelete(row) {
      // 在"我的作品"页面中，所有作品都允许删除
      return true
    },
    /**
     * @description 确认删除作品
     * @param {Object} row 作品行数据
     */
    confirmDelete(row) {
      const that = this
      this.$confirm({
        title: '确认删除',
        content: `确定要删除作品"${row.name_cn}"吗？此操作不可撤销。`,
        okText: '确认删除',
        okType: 'danger',
        cancelText: '取消',
        onOk() {
          return that.deleteProduct(row.id)
        }
      })
    },
    /**
     * @description 删除作品
     * @param {Number} productId 作品ID
     */
    deleteProduct(productId) {
      return deleteProduct(productId)
        .then(() => {
          this.$message.success('作品删除成功')
          // 重新获取数据
          this.getList(this.pagination.current)
        })
        .catch(error => {
          console.error('删除作品失败:', error)
          this.$message.error('删除作品失败，请稍后重试')
        })
    },
    /**
     * @description 下载报名表
     * @param {Object} row 作品行数据
     */
    downloadForm(row) {
      this.$message.info('开始下载报名表...')
      productsWordExport(row.id)
        .then(res => {
          const url = res.file_url
          if (url) {
            window.open(url, '_blank')
          } else {
            this.$message.error('未获取到下载链接')
          }
        })
        .catch(err => {
          console.error(err)
        })
    }
  }
}
</script>
<style scoped>
.searchBox {
  background: #ffffff;
  width: 100%;
  height: 103px;
  border-radius: 2px;
  padding: 32px 10px;
  display: flex;
}

.infoBox {
  background: #ffffff;
  width: 100%;
  height: 103px;
  border-radius: 2px;
  padding: 15px 32px;
}

.infoBox span {
  margin-left: 10px;
}

.table {
  margin-top: 30px;
}

.edit {
  cursor: pointer;
}

.edit span {
  margin-left: 5px;
}

.ant-col-8 {
width: 41%;
}

.ant-col-16{
  width: 58%;
}
</style>
<style>
.myProduct .anticon-eye-o {
  font-size: 24px !important;
}

/* 确保删除按钮稳定显示 */
.myProduct .ant-btn-danger {
  position: relative !important;
  z-index: 1;
  pointer-events: auto;
}

.myProduct .ant-btn-danger:hover {
  position: relative !important;
  z-index: 1;
  pointer-events: auto;
}

</style>
